var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payCheckWrap"},[_c('div',{staticClass:"payCheckText"},[_vm._v("信息已提交")]),_c('div',{staticClass:"payBtnModule"},[_c('div',{staticClass:"yycx",on:{"click":_vm.backSY}},[_vm._v("预约出行")])])])}
var staticRenderFns = []

export { render, staticRenderFns }